const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export const C = {
  navy: "#1D3557", teal: "#2A9D8F", red: "#E63946", orange: "#F4A261",
  slate: "#457B9D", border: "#DCD9D0", muted: "#8A8A80", ink: "#0A0A0A", soft: "#5C5C54",
};
export const PALETTE = [C.navy, C.teal, C.orange, C.slate, C.red, "#7A9E7E", "#B8B5AA", "#6D597A", "#E9C46A", "#264653"];

export const fmtPeriod = (p, gran) => {
  const [y, m, d] = p.split("-").map(Number);
  if (gran === "month") return `${MONTHS[m - 1]} ${String(y).slice(2)}`;
  return `${d} ${MONTHS[m - 1]}`;
};

export const fmtHours = (h) => {
  if (h === null || h === undefined) return "—";
  if (h < 1 / 60) return "<1 min";
  if (h < 1) return `${Math.round(h * 60)} min`;
  if (h < 48) return `${h.toFixed(1)} hrs`;
  return `${(h / 24).toFixed(1)} days`;
};

export const fmtDays = (d) => (d === null || d === undefined ? "—" : fmtHours(d * 24));

// Percent change; lowerIsBetter flips the colour logic.
export const delta = (cur, prev, lowerIsBetter = false) => {
  if (cur === null || cur === undefined || prev === null || prev === undefined) return null;
  if (prev === 0) return cur === 0 ? { pct: 0, good: null } : null;
  const pct = Math.round(((cur - prev) / prev) * 100);
  if (pct === 0) return { pct, good: null };
  return { pct, good: lowerIsBetter ? pct < 0 : pct > 0 };
};
